import { createSelector } from '@reduxjs/toolkit'

import { queryView, type QueryResultLike, type QueryView } from '@krp/client-runtime'

import type { AqsiDiagnosticsVm, AqsiProfile } from './types'

export interface AqsiDiagnosticsVmInput {
  profile: QueryResultLike<AqsiProfile>
}

function viewOf<T>(pick: (input: AqsiDiagnosticsVmInput) => QueryResultLike<T>) {
  return createSelector(
    [
      (input: AqsiDiagnosticsVmInput) => pick(input).isUninitialized,
      (input: AqsiDiagnosticsVmInput) => pick(input).isLoading,
      (input: AqsiDiagnosticsVmInput) => pick(input).isError,
      (input: AqsiDiagnosticsVmInput) => pick(input).isSuccess,
      (input: AqsiDiagnosticsVmInput) => pick(input).error,
      (input: AqsiDiagnosticsVmInput) => pick(input).data,
    ],
    (isUninitialized, isLoading, isError, isSuccess, error, data): QueryView =>
      queryView(
        {
          isUninitialized,
          isLoading,
          isError,
          isSuccess,
          ...(error !== undefined ? { error } : {}),
          ...(data !== undefined ? { data } : {}),
        },
        () => false,
      ),
  )
}

/** Фабрика vm панели диагностики одного кабинета AQSI: по экземпляру на binding. */
export const makeSelectAqsiDiagnosticsVm = () => {
  const selectProfile = viewOf((input) => input.profile)
  return createSelector(
    [selectProfile, (input: AqsiDiagnosticsVmInput) => input.profile.data],
    (profileView, profile): AqsiDiagnosticsVm => ({
      profile: { query: profileView, value: profileView.status === 'ready' ? (profile ?? null) : null },
    }),
  )
}
